import { css } from "@compiled/react";
import { defineMessage, FormattedMessage } from "react-intl";

import { N700 } from "@atlaskit/theme/colors";

import { BanditsHeaderWrapper } from "@/utils/anchor-queries/bandits-components";

import { EmbeddedSignupModuleWrapper } from "../../../embedded-signup-module-wrapper";
import { ExistingProductText } from "../components";
import { useSignupFormContext } from "../hooks";

import { EmailForm } from "./social-proof-paid/email-form";
import { SocialEndorsement } from "./social-proof-paid/social-endorsement";

const confluenceEmbeddedExistingText = defineMessage({
    id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
    defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
});

export const CFindEmbeddedSignupForm = () => {
    const { productName, customHeader } = useSignupFormContext();

    const defaultHeader = (
        <FormattedMessage
            id="BxpUiSignup.EmbeddedSignupForm1466.header.confluence.features"
            defaultMessage="Goodbye silos, hello teamwork with Confluence"
        />
    );

    return (
        <EmbeddedSignupModuleWrapper hideFooter={true}>
            <div css={containerStyle} data-testid="signup-form">
                <h1 css={headerStyle}>
                    <BanditsHeaderWrapper product="confluence" type="header">
                        {customHeader || defaultHeader}
                    </BanditsHeaderWrapper>
                </h1>
                <h2 css={subheaderStyle}>
                    <BanditsHeaderWrapper product="confluence" type="subheader">
                        <FormattedMessage
                            id="BxpUiSignup.SignupForm.subheader.1"
                            defaultMessage="It's free for up to 10 users — no credit card needed."
                        />
                    </BanditsHeaderWrapper>
                </h2>
                <EmailForm />
                <SocialEndorsement />
                <ExistingProductText
                    messageOverride={confluenceEmbeddedExistingText}
                    productName={productName}
                />
            </div>
        </EmbeddedSignupModuleWrapper>
    );
};

const containerStyle = css({
    alignItems: "stretch",
    backgroundColor: "white",
    // eslint-disable-next-line
    boxShadow: "0px 14px 14px -4px rgba(0, 0, 0, 0.10)",
    borderRadius: "20px",
    color: N700,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "32px 50px",
    width: "468px"
});

const headerStyle = css({
    paddingInlineEnd: "64px",
    textAlign: "left !important"
});

const subheaderStyle = css({
    fontSize: "16px !important",
    fontWeight: "300 !important",
    textAlign: "left !important"
});
